import axios from "axios";
// Adjust this import path based on where config/api.js is located relative to apiServices
import { API_BASE_URL } from "../config/api"; 

const getAuthHeaders = (token) => ({
  headers: {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  },
});

export const getAllBetLocks = async (token) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/admin/betlock/`, getAuthHeaders(token));
    return response.data;
  } catch (error) {
    console.error("Error fetching bet locks:", error);
    return { success: false, message: error.response?.data?.message || error.message };
  }
};

export const lockMultipleUsers = async (token, userIds, type, lock = true) => {
  try {
    // Backend expects: { users: [{ user_id, match_odds, other_markets }] } for lockMultipleBets
    // OR separate lock/unlock endpoints.
    
    // Existing backend 'lockMultipleBets' expects array of user objects with states.
    // Existing 'unlockMultipleBets' expects { user_ids: [] }.
    
    // BUT the frontend components call this function with: 
    // lockMultipleUsers(token, lockedUsers, 'other_markets') (implicit lock=true)
    // lockMultipleUsers(token, unlockedUsers, 'other_markets', false)

    if (lock) {
        // Prepare payload for locking/updating
        // We need to map userIds to objects.
        // For 'match_odds', we set match_odds=true. For 'other_markets', other_markets=true.
        // BUT wait, this overrides the OTHER flag if we are not careful?
        // The backend 'lockMultipleBets' updates ONLY provided fields if user exists.
        
        const usersPayload = userIds.map(id => {
            const obj = { user_id: id };
            if (type === 'match_odds') obj.match_odds = true;
            if (type === 'other_markets') obj.other_markets = true;
            return obj;
        });

        const response = await axios.post(
            `${API_BASE_URL}/admin/betlock/lock/multiple`,
            { users: usersPayload },
            getAuthHeaders(token)
        );
        return response.data;
    } else {
        // Unlock logic. 
        // The backend `unlockMultipleBets` sets BOTH to false. 
        // If we only want to unlock ONE type, we should use `lockMultipleBets` and set that type to false.
        
        const usersPayload = userIds.map(id => {
            const obj = { user_id: id };
            if (type === 'match_odds') obj.match_odds = false;
            if (type === 'other_markets') obj.other_markets = false;
            return obj;
        });

        const response = await axios.post(
            `${API_BASE_URL}/admin/betlock/lock/multiple`, // Use lock endpoint to update to false
            { users: usersPayload },
            getAuthHeaders(token)
        );
        return response.data;
    }

  } catch (error) {
    console.error("Error updating multiple users:", error);
    return { success: false, message: error.response?.data?.message || error.message };
  }
};

export const lockAllOtherMarkets = async (token) => {
  try {
    const response = await axios.post(
        `${API_BASE_URL}/admin/betlock/lock/all/othermarkets`, 
        {}, 
        getAuthHeaders(token)
    );
    return response.data;
  } catch (error) {
    return { success: false, message: error.message };
  }
};

export const lockAllMatchOdds = async (token) => {
  try {
     const response = await axios.post(
        `${API_BASE_URL}/admin/betlock/lock/all/matchodds`, 
        {}, 
        getAuthHeaders(token)
    );
    return response.data;
  } catch (error) {
    return { success: false, message: error.message };
  }
};

export const lockMatchForUser = async (token, uid, eventId) => {
  try {
    const response = await axios.post(
        `${API_BASE_URL}/admin/betlock/lock/match`,
        { user_id: uid, event_id: eventId },
        getAuthHeaders(token)
    );
    return response.data;
  } catch (error) {
    return { success: false, message: error.message };
  }
};

export const unlockMatchForUser = async (token, uid, eventId) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}/admin/betlock/unlock/match`,
            { user_id: uid, event_id: eventId },
            getAuthHeaders(token)
        );
        return response.data;
      } catch (error) {
        return { success: false, message: error.message };
      }
};

export const getMatchLocks = async (token, eventId) => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}/admin/betlock/match/${eventId}`,
            getAuthHeaders(token)
        );
        return response.data;
      } catch (error) {
        return { success: false, message: error.message };
      }
};
// ... existing exports ...

// ✅ NEW: Dynamic Sports Lock API calls (Granular Locking)

export const getLocksByMarket = async (token, marketId) => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}/admin/sports-lock/get-by-market/${marketId}`,
            getAuthHeaders(token)
        );
        return response.data;
    } catch (error) {
        return { success: false, message: error.message };
    }
};

export const updateSportsLocksBulk = async (token, locks) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}/admin/sports-lock/update-bulk`,
            { locks },
            getAuthHeaders(token)
        );
        return response.data;
    } catch (error) {
         return { success: false, message: error.message };
    }
};
